/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/interface/current-host-protocol': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/HostProtocol',
      },
    },
  },

  '/interface/security-options': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/SecurityOptions',
      },
    },
  },

  '/interface/bundle-id-swd-direct-access': {
    put: {
      minApiVersion: 1.23,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-serial-access': {
    put: {
      minApiVersion: 1.23,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-modbus-direct-access': {
    put: {
      minApiVersion: 1.23,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-tapnpass-control-access': {
    put: {
      minApiVersion: 1.23,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-firmware-update-access': {
    put: {
      minApiVersion: 1.35,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-mqtt-ids-access': {
    put: {
      minApiVersion: 1.35,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-variable-config-access': {
    put: {
      minApiVersion: 2.11,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/bundle-id-file-system-access': {
    put: {
      minApiVersion: 2.13,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/config-format-version': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/app-name': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 24,
      },
    },
  },

  '/interface/config-version': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'version',
        pattern: '^([0-9]+)\\.([0-9]+)\\.([0-9]+)$',
      },
    },
  },

  '/interface/app-path': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        maxLength: 100,
        type: 'string',
      },
    },
  },

  '/interface/nfc/pairing-mode': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/NfcPairingMode',
      },
    },
  },

  '/interface/pairing-options': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/WirelessPairingOptions',
      },
    },
  },

  '/interface/power-optimisation-level': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/LowPowerOptimizationLevel',
      },
    },
  },

  '/interface/cpu-frequency-options': {
    put: {
      minApiVersion: 2.15,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/CpuFrequencySpeed',
      },
    },
  },

  '/interface/power-optimisation-options': {
    put: {
      minApiVersion: 2.15,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/PowerOptimizationOptions',
      },
    },
  },

  '/interface/max-low-power-time': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint32',
      },
    },
  },

  '/interface/auto-reboot-timeout': {
    put: {
      minApiVersion: 2.11,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/authorized-host-protocol': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'array',
        items: {
          $ref: './definitions.yaml#/HostProtocol',
        },
      },
    },
  },

  '/interface/universal-link': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 100,
      },
    },
  },

  '/interface/network-options': {
    put: {
      minApiVersion: 2.13,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/NetworkOptions',
      },
    },
  },

  '/interface/radio-mix-enabled': {
    put: {
      minApiVersion: 2.13,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint8',
      },
    },
  },

  '/interface/nfc_connection_priority': {
    put: {
      minApiVersion: 1.85,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/NfcConnectionPriority',
      },
    },
  },

  '/interface/nfc-autolog-profile-id': {
    put: {
      minApiVersion: 1.55,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/interface/host-inactivity-period': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint16',
        minimum: 0,
        maximum: 255,
      },
    },
  },

  '/interface/application-data': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/interface/certificate/public-key': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/interface/certificate/private-key': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/interface/certificate/root-key': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/interface/product-code': {
    put: {
      minApiVersion: 1.113,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/interface/special-feature/{featureId}': {
    put: {
      minApiVersion: 1.23,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },
};
